import { cloneDeep } from 'lodash';
import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

// mutations declarations
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_USER_ACCOUNTS = 'SET_USER_ACCOUNTS';
export const SET_ACTIVE_ACCOUNT_ID = 'SET_ACTIVE_ACCOUNT_ID';
export const MEMBERS = 'MEMBERS';
export const SET_LOADING = 'SET_LOADING';
export const ADD_MEMBERS = 'ADD_MEMBERS';
export const REMOVE_TEMP_MEMBER = 'REMOVE_TEMP_MEMBER';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const UPDATE_ACTIVE = 'UPDATE_ACTIVE';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_USER_ACCOUNTS](state, accounts) {
		Vue.set(state, 'userAccounts', accounts);
	},
	[SET_ACTIVE_ACCOUNT_ID](state, id) {
		Vue.set(state, 'activeAccountId', id);
	},
	[SET_ACCOUNT](state, account) {
		const userAccounts = cloneDeep(state.userAccounts);
		const accountLinkIndex = userAccounts.findIndex((accountLink) => accountLink.account?.id === account.id);
		const newAccountLink = { ...userAccounts[accountLinkIndex], account };
		userAccounts[accountLinkIndex] = newAccountLink;
		Vue.set(state, 'userAccounts', userAccounts);
	},
	[DELETE_ACCOUNT](state, accountId) {
		if (accountId) {
			const userAccounts = cloneDeep(state.userAccounts);
			Vue.set(
				state,
				'userAccounts',
				userAccounts.filter((x) => x.account?.id !== accountId)
			);
		}
	},
	[MEMBERS](state, members) {
		Vue.set(state, 'members', members);
	},
	[SET_LOADING](state, value) {
		state.loadingMembers = value;
	},
	[ADD_MEMBERS](state, members) {
		state.members.push(...members);
	},
	[REMOVE_TEMP_MEMBER](state, uID) {
		const tempMemberIndex = state.members.findIndex((m) => m.temp && m.id === uID); // First filter
		if (tempMemberIndex) {
			Vue.delete(state.members, tempMemberIndex);
		}
	},
	[UPDATE_ROLE](state, payload) {
		const { uID, roleCode } = payload;
		const memberIndex = state.members.findIndex((m) => !m.temp && m.id === uID);
		if (memberIndex) {
			Vue.set(state.members[memberIndex], 'role', roleCode);
		}
	},
	[UPDATE_ACTIVE](state, payload) {
		const { uID, status } = payload;
		const memberIndex = state.members.findIndex((m) => !m.temp && m.id === uID);
		if (memberIndex) {
			Vue.set(state.members[memberIndex], 'status', status);
		}
	},
};

export default mutations;
